// extracted by mini-css-extract-plugin
module.exports = {"changelog":"Changelog_changelog__31S4N"};